import { useContextState } from "../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        clean: {
            padding: '6px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
            '&.add': {
                color: colors.color4,
                fontSize: '2.6rem',
                padding: '0px',
                paddingRight: '2px',
            },
        },
        flex: {
            display: 'flex',
            alignItems: 'center',
            '&.just': {
                justifyContent: 'space-between'
            },
            '&.wrap': {
                flexWrap: 'wrap'
            },
            '&.gp1': {
                gap: 1
            },
            '&.mb2': {
                marginBottom: 2
            }
        },
        title: {
            minHeight: '53px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center'
        },
    }
}

export { useStyles }
